export default __webpack_public_path__ + "5fa637cefd6519d5b0863403298b0dcd.svg";